import descriptionsRu from "./internationalDescriptions.ru";

/**
 * Returns the description for an international listing in the current language.
 * Falls back to the original English description if no translation exists.
 */
export function getIntlDescription(listing, lang) {
  if (lang === "ru") {
    return descriptionsRu[listing.slug] ?? listing.description;
  }
  return listing.description;
}
